module.exports = __webpack_public_path__ + "img/user.43ec709d.png";